export default "__VITE_ASSET__wSyfSVj8__"